import { EXERCISE_COPY, exerciseKindSchema, followingExercise, nextStep } from '@echo/core';
import { Button, SpeechBubble } from '@echo/ui-web';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ContentFrame, ExercisePage } from '@/components/exercise-frame';
import { COMPLETE_ART } from '@/lib/complete-art';

export const Route = createFileRoute('/_app/exercise/$kind/complete')({
  params: {
    parse: ({ kind }) => ({ kind: exerciseKindSchema.parse(kind) }),
    stringify: ({ kind }) => ({ kind }),
  },
  component: ExerciseCompletePage,
});

/** Per-exercise completion. */
function ExerciseCompletePage() {
  const { kind } = Route.useParams();
  const { t } = useLingui();
  const navigate = useNavigate();
  const copy = EXERCISE_COPY[kind];
  const next = followingExercise(kind);
  const proceed = () => {
    if (!next) {
      void navigate({ to: '/progress', replace: true });
    } else if (nextStep(next, undefined) === 'choose') {
      void navigate({ to: '/exercise/$kind/choose', params: { kind: next }, replace: true });
    } else {
      void navigate({
        to: '/exercise/$kind/intro',
        params: { kind: next },
        replace: true,
      });
    }
  };

  return (
    <ExercisePage>
      <ContentFrame
        footer={
          <>
            <Button variant="ghost" onClick={() => navigate({ to: '/', replace: true })}>
              {t`Back to home`}
            </Button>
            <Button onClick={proceed}>{t`Continue`}</Button>
          </>
        }
      >
        <SpeechBubble className="px-content-md">{t(copy.complete.body)}</SpeechBubble>
        <img
          src={COMPLETE_ART[kind]}
          alt={t`A cheerful brain character celebrating`}
          className="h-[321px] w-[375px] max-w-full object-contain"
        />
      </ContentFrame>
    </ExercisePage>
  );
}
